import React from "react";

const UserContext = React.createContext<AppUser | null>(null)

export default UserContext
